exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-content {\n  height: 300px; }\n\n.icon.icon-green img {\n  -webkit-filter: grayscale(0) blur(0) !important;\n          filter: grayscale(0) blur(0) !important; }\n\n.icon img {\n  width: 100px;\n  -webkit-filter: grayscale(1) blur(5px);\n          filter: grayscale(1) blur(5px); }\n\n.card.card-pricing.card-plain {\n  width: 19%;\n  float: left;\n  margin-right: 10px;\n  height: auto;\n  min-width: -webkit-fit-content;\n  min-width: -moz-fit-content;\n  min-width: fit-content; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-complementos/css/cmp-complementos.component.scss
// module id = ../../../../../src/app/layout/content/seguridad/emisor/cmp-complementos/css/cmp-complementos.component.scss
// module chunks = main